import { useBFFOriginUrlContext } from '../providers/origin-provider-context';

/**
 * Hook that returns the context of a forced origin url (used for supporting global shortcuts locally)
 */
const useOriginUrl = () => {
	const context = useBFFOriginUrlContext();
	return context;
};

export default useOriginUrl;
